// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__BaPS+"};